import { useState } from 'react';

interface GeocodingResult {
  lat: number;
  lng: number;
}

const useGeocoding = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Search for an address and convert it to coordinates
   * @param address - The address to search for
   * @returns - Promise that resolves to coordinates {lat, lng} or null if not found
   */
  const searchAddress = async (address: string): Promise<GeocodingResult | null> => {
    setLoading(true);
    setError(null);
    
    try {
      // Create a new geocoder instance
      const geocoder = new google.maps.Geocoder();
      
      return new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
          setLoading(false);
          
          if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
            const location = results[0].geometry.location;
            resolve({
              lat: location.lat(),
              lng: location.lng()
            });
          } else {
            setError(`Geocoding failed: ${status}`);
            reject(new Error(`Geocoding failed: ${status}`));
          }
        });
      });
    } catch (err) {
      setLoading(false);
      setError('Geocoding service failed');
      return null;
    }
  };

  return {
    searchAddress,
    loading,
    error
  };
};

export default useGeocoding;
